import React, {useEffect, useState} from "react"
import { useAuth0 } from "../react-auth0-wrapper"
import { Link } from "react-router-dom"
import { useLocation } from "react-router-dom"
import { makeStyles } from "@mui/styles"
import IconButton from "@mui/material/IconButton"
import MenuIcon from "@mui/icons-material/Menu"
import Hidden from "@mui/material/Hidden"
import Toolbar from "@mui/material/Toolbar"
import Typography from "@mui/material/Typography"
import MenuItem from "@mui/material/MenuItem"
import Menu from "@mui/material/Menu"
import Button from "@mui/material/Button"
// import { ReactComponent as PhoneSvg } from "../assets/phonehandset.svg"
import BetaNotice from "./BetaNotice"
import HomeIcon from "@mui/icons-material/Home"

const useStyles = makeStyles(theme => ({
  root: {
    flex: "1 0 auto",
    overflowX: "hidden",
    width: "60vw",
    justify: "center"
  },
  toolbar: {
    backgroundColor: "#ffffff",
  },
  betaChip: {
    marginRight: theme.spacing(2),
  },
  svg: {
    height: "2vh",
    marginRight: theme.spacing(2),
    verticalAlign: "middle"
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    display: "inline"
  },
  subtitleLarge: {
    marginRight: 30,
  },
  subtitleAuthLarge: {
    marginRight: 30,
    fontColor: "blue"
  },
  subtitleSmall: {
    marginLeft: 30,
  },
  subtitleAuthSmall: {
    marginLeft: 30,
  },
  loginText: {
    color: "black"
  },
  icon: {
    marginLeft: 10,
    marginRight: 10
  },
  navLinks: {
    color: theme.palette.primary.dark,
    textDecoration: "none",
    textTransform: "none",
  },
  menuItem: {
    justifyContent: "flex-end",
  },
  headerGameName: {
    paddingLeft: theme.spacing(1)
  },
  homeIcon: {
    verticalAlign: "middle",
    marginRight: theme.spacing(1)
  }
}))

export default function MenuAppBar() {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0()
  const classes = useStyles()
  const location = useLocation()

  const [menuOpen, setMenuOpen] = useState(null)

  const [showHeader, setShowHeader] = useState()

  const handleMenuClick = (event) => {
    setMenuOpen(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuOpen(null)
  }

  const navLinks = [
    {name: "home", url: "/",  hashlink: false},
    {name: "play", url: "/play", hashlink: true},
  ]

  useEffect(() => {
    setShowHeader(["/privacy", "/contact", "/terms", "/profile"].includes(window.location.pathname))
  }, [location])

  return (
    <Toolbar className={classes.toolbar}>
      <div className={classes.title}>
        <Typography align="left" variant="h6" display="inline">
          <Link to={"/"}>
            {/* <PhoneSvg className={classes.svg} title="Link To Home" /> */}
            <HomeIcon color="primary" className={classes.homeIcon} />
          </Link>
          <BetaNotice />
          {showHeader &&
            <Typography className={classes.headerGameName} align="center" variant="caption" display="inline">
             PHONE BOOTH GAME
            </Typography>
          }
        </Typography>
      </div>

      {process.env.REACT_APP_MAINTENANCE !== "TRUE" && (
        <>
          <Hidden smUp>
            <IconButton
              onClick={handleMenuClick}
              aria-controls="simple-menu"
              aria-haspopup="true"
              size="large"
            >
              <MenuIcon />
            </IconButton>

            <Menu
              id="simple-menu"
              anchorEl={menuOpen}
              keepMounted
              open={Boolean(menuOpen)}
              onClose={handleMenuClose}
              className={classes.popoutMenu}
            >
              {navLinks.map((link) => (
                <MenuItem
                  key={link.name}
                  className={classes.menuItem}
                  onClick={handleMenuClose}
                >
                  <Link className={classes.navLinks} to={link.url}>
                    <Typography
                      variant="body2"
                      className={classes.subtitleSmall}
                    >
                      {link.name}
                    </Typography>
                  </Link>
                </MenuItem>
              ))}

              {!isAuthenticated && (
                <MenuItem>
                  <Link
                    to={"/"}
                    className={classes.navLinks}
                    onClick={() =>
                      loginWithRedirect({ appState: { targetUrl: "/profile" } })
                    }
                  >
                    <Typography
                      variant="body2"
                      className={classes.subtitleSmall}
                    >
                      login / signup
                    </Typography>
                  </Link>
                </MenuItem>
              )}
              {isAuthenticated && (
                <React.Fragment>
                  <MenuItem className={classes.menuItem}>
                    <Link className={classes.navLinks} to={"/profile"}>
                      <Typography
                        variant="body2"
                        className={classes.subtitleSmall}
                      >
                        my games
                      </Typography>
                    </Link>
                  </MenuItem>
                  <MenuItem className={classes.menuItem}>
                    <Link
                      to={"/"}
                      className={classes.navLinks}
                      onClick={() => logout()}
                    >
                      <Typography
                        variant="body2"
                        className={classes.subtitleSmall}
                      >
                        logout
                      </Typography>
                    </Link>
                  </MenuItem>
                </React.Fragment>
              )}
            </Menu>
          </Hidden>
          <Hidden smDown>
            <Link className={classes.navLinks} to={"/play"}>
              <Typography variant="body2" className={classes.subtitleLarge}>
                play
              </Typography>
            </Link>
            {!isAuthenticated && (
              <Button
                variant="contained"
                color="primary"
                className={classes.navLinks}
                onClick={() =>
                  loginWithRedirect({ appState: { targetUrl: "/profile" } })
                }
              >
                <Typography variant="body2" className={classes.loginText}>
                  login / signup
                </Typography>
              </Button>
            )}
            {isAuthenticated && (
              <React.Fragment>
                <Link className={classes.navLinks} to={"/profile"}>
                  <Typography
                    variant="body2"
                    className={classes.subtitleAuthLarge}
                  >
                    my games
                  </Typography>
                </Link>
                <Link
                  to={"/"}
                  className={classes.navLinks}
                  onClick={() => logout()}
                >
                  <Typography
                    variant="body2"
                    className={classes.subtitleAuthLarge}
                  >
                    logout
                  </Typography>
                </Link>
              </React.Fragment>
            )}
          </Hidden>
        </>
      )}
    </Toolbar>
  )
}
